import DeviceManager from '../utils/device-manager';

const VerticalTimeline = {
    desktopInitialized: false,
    tabs: [],
    sender: 'timeline',
    currentSender: 'timeline',

    init() {
        const $timelines = document.querySelectorAll('.js-vertical-timeline');

        $timelines.forEach($timeline => {
            this.initTimeline($timeline);
        });
    },

    initTimeline($timeline) {
        const click_ev = document.createEvent("MouseEvent");
        click_ev.initEvent("click", false /* bubble */, true /* cancelable */);
        
        DeviceManager.addCallback(attr => {
            if (!this.desktopInitialized && DeviceManager.isGreaterThan(attr.current, 'md')) {
                this.initDesktop($timeline);
            } else if (this.desktopInitialized && !DeviceManager.isGreaterThan(attr.current, 'md')) {
                this.destroyDesktop($timeline);
            }

            const $tabs = $timeline.querySelectorAll('.js-vertical-timeline-tab');
            const $tabsSecondary = document.querySelectorAll('.js-vertical-timeline-tab-secondary');
            const $menuItems = $timeline.querySelectorAll('.js-vertical-timeline-menu-item');
            const $select = $timeline.querySelector('.js-vertical-timeline-select');
            // console.log('menuItem[0] : ', $menuItems[0]);

            document.addEventListener('changeTab', e => {
                if (e.sender != 'timeline') {
                    this.currentSender = 'notMe'
                    $menuItems[e.tabIndex].dispatchEvent(click_ev);
                }
            });

            $menuItems.forEach(($menuItem, index) => {
                $menuItem.addEventListener('click', e => {
                    const tabId = $menuItem.dataset.tab;
                    // console.log('event:', e);
                    if (this.currentSender == this.sender) {
                        var tabCCMPartenaireEvent = new CustomEvent('changeTab');
                        tabCCMPartenaireEvent.tabIndex = index;
                        tabCCMPartenaireEvent.sender = this.sender;
                        document.dispatchEvent(tabCCMPartenaireEvent);
                    }
                    this.currentSender = this.sender;

                    $menuItems.forEach($item => {
                        if ($item.dataset.tab === tabId) {
                            $item.classList.add('active');
                        } else {
                            $item.classList.remove('active');
                        }
                    });

                    $tabs.forEach($tab => {
                        if ($tab.dataset.tabId === tabId || $tab.dataset.tabId === tabId + '-ghost') {
                            $tab.classList.remove('hide');
                        } else {
                            $tab.classList.add('hide');
                        }
                    });

                    $tabsSecondary.forEach($tab => {
                        if ($tab.dataset.tabId === tabId) {
                            $tab.classList.remove('hide');
                        } else {
                            $tab.classList.add('hide');
                        }
                    });

                    $select.value = tabId;
                });
                
                if (index === 0) {
                    $menuItem.dispatchEvent(click_ev);
                }
            });

            $select.addEventListener('change', e => {
                const tabId = $select.value;

                $menuItems.forEach($menuItem => {
                    if ($menuItem.dataset.tab === tabId) {
                        $menuItem.dispatchEvent(click_ev);
                    }
                });
            });
        });
    },

    initDesktop($timeline) {
        this.desktopInitialized = true;

        if (!document.body.classList.contains('ie')) {
            this.initAnimation($timeline);
        }
    },

    destroyDesktop($timeline) {
        this.desktopInitialized = false;

        this.tabs.forEach(tabInfo => {
            tabInfo.observer.unobserve(tabInfo.$tab);
            window.removeEventListener('scroll', tabInfo.onScroll);
        });
    },

    initAnimation($timeline) {
        const $tabsContainer = $timeline.querySelector('.js-vertical-timeline-tabs');
        const $tabs = $timeline.querySelectorAll('.js-vertical-timeline-tab');

        $tabs.forEach($tab => {
            this.tabs.push({
                $tab,
                $ghost: null,
                observer: null,
                onScroll() {},
            });
        });

        this.tabs.forEach(tabInfo => {
            const maxHeight = tabInfo.$tab.clientHeight;

            if (!tabInfo.$ghost) {
                tabInfo.$ghost = tabInfo.$tab.cloneNode();
                tabInfo.$ghost.innerHTML = tabInfo.$tab.innerHTML;
                tabInfo.$ghost.classList.add('vertical-timeline-tab-ghost');
                tabInfo.$ghost.style.maxHeight = maxHeight + 'px';
                $tabsContainer.appendChild(tabInfo.$ghost);
            }

            tabInfo.onScroll = () => {
                const headerHeight = document.querySelector('#header').clientHeight;
                const middleOfTheScreen = (window.innerHeight / 2) + headerHeight;
                const tabPositionFromTop = tabInfo.$tab.getBoundingClientRect().top + window.pageYOffset;
                const scrollPosIntoTab = (window.pageYOffset + headerHeight) - (tabPositionFromTop - middleOfTheScreen);
                let percent = ((scrollPosIntoTab * 100) / maxHeight);
                percent = (percent < 0 ? 0 : (percent > 100 ? 100 : percent));

                tabInfo.$ghost.style.height = (percent < 100 ? percent - 1.5 : percent) + '%';
            }

            tabInfo.observer = new IntersectionObserver(entries => {
                const intersectionRatio = entries[0]['intersectionRatio'];

                const tabBottomOffset = tabInfo.$tab.getBoundingClientRect().bottom;

                if (tabBottomOffset < 0) {
                    window.removeEventListener('scroll', tabInfo.onScroll);
                    tabInfo.$ghost.style.height = '100%';
                } else if (intersectionRatio > 0) {
                    tabInfo.onScroll();
                    window.addEventListener('scroll', tabInfo.onScroll);
                } else {
                    window.removeEventListener('scroll', tabInfo.onScroll);
                    tabInfo.$ghost.style.height = '0%';
                }
            }, { threshold: 0 });

            tabInfo.observer.observe(tabInfo.$tab);
        });
    }
}

export default VerticalTimeline;